export const GET_PLAYLIST = 'GET_PLAYLIST'
export const IS_FETCHING = 'IS_FETCHING'

export const getPlayListAC = (playlist) => ({type: GET_PLAYLIST, playlist})
export const isFetchingAC = (isFetching) => ({type: IS_FETCHING, isFetching })
